import fetchCountryStateList from './fetchCountryStateList';

export default fetchCountryStateList;
